var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAvVillas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.2 45",
    style: {
      enableBackground: "new 0 0 161.2 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#107569;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.8,4.8c-9.6,6.1-14.3,18.8-14.3,18.8C24.3,14.2,10,16.3,10,16.3c22.1,3.5,20.4,21.2,20.4,21.2 c1.9-9.7,8.8-21.3,10.5-23.7C50,1.9,59.8,0,59.8,0c-6.5,2.9-11,7.4-11,7.4c1.1,1,2,2.2,2.7,3.6c4.7,9.3-1.6,22.2-16.4,29.8 C22,47.6,6.2,46,1.5,36.7c-4.7-9.3,1.5-21.7,16-29.6C27.1,2,37.8,1.4,44.8,4.8 M25.4,27.2c0,0-13.4-2.3-13.4,2.9 c0,2.2,2.1,5,9.4,6.1c1.2,0.2,5.6,0.8,8.5-1.1c0,0-1.7,3.7-9.9,3.1c-1.4-0.1-9.8-0.8-12.7-6.4C6.6,30.3,6.5,26,12.6,25 C15.9,24.5,22.1,24.8,25.4,27.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,20.8h4.6l1.3-6.4c0.2-1.2,0.5-2.8,0.6-3.7c0.7-0.4,1.2-0.6,2.2-0.8c2-0.3,2.4,0.7,2.2,2.2 c-0.1,0.7-0.2,1.4-0.3,2.1l-1.3,6.6h4.6l1.3-6.5c0.3-1.5,0.6-2.8,0.6-3.7c0-2.7-0.8-4.3-3.6-4.3c-2.5,0-3.7,1-5,1.9h-0.1l0.3-1.6 h-4.6c-0.1,1.3-0.4,2.7-0.6,3.9L96.6,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.1,16.1c-0.2,0-0.4,0-0.6,0c-1.6,1.6-3.4,1.8-4.4,1.8c-2,0-3.2-1.3-3-3.3c0.2-2.8,1.7-5.2,4.3-5.3 c0.8,0,2.6,0,4,1.6c0.2,0,0.6,0,0.8,0l0.5-3.7c-1.3-0.6-3.6-1.1-4.8-1.1c-5.6-0.1-9.4,4.1-9.5,8.7c0,3.9,2.2,6.1,6.2,6.1 c1.8,0,4.8-0.6,5.8-0.9L126.1,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.1,20.8h4.7c0.5-4.2,1.5-7.6,1.7-9.8c0.3-3.1-1.6-4.8-6-4.8c-2.1,0-3.9,0.3-5.8,0.6l-0.5,3.5 c1.6-0.8,3.5-1.1,5.2-1.1c1.6,0,2.4,0.7,2.4,1.7c0,0.2,0,0.4,0,0.6c-0.6-0.1-1.5,0.1-2.5,0.1c-4.2,0.2-7.4,1.9-7.7,5.4 c-0.2,2.8,1.1,4,4.1,4c1.8,0,3-0.7,4.5-1.8l0,0.3L89.1,20.8z M85.3,17c-0.2-1.6,1.1-2.7,3.6-2.8c0.3,0,0.8-0.1,1.5-0.1 c-0.2,1.6-0.5,3-0.5,3c-0.7,0.6-1.6,0.9-2.5,1C86.3,18.2,85.4,17.9,85.3,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.2,12.5c-0.4,3.9-1.7,5.4-3.8,5.4c-1.6,0-3-1-2.2-4.4c0.5-2.2,1.4-4.3,3.6-4.3 C137.5,9.2,138.5,10,138.2,12.5 M142.9,12.1c0.4-3.5-2.3-6-6.4-6c-5.2-0.1-9.1,3.8-9.1,8.6c0,3.5,1.1,6.2,6.2,6.2 C138.9,20.9,142.2,17.9,142.9,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,20.8l8.4-0.1c4.2-0.1,7.8-1.6,8.4-5.9c0.3-2-0.4-3.5-3.2-4.2c2.9-1.3,3.6-3.4,3.6-4.9 c0-3.1-3.3-3.6-5.2-3.6H67L63.2,20.8z M71,5.5h1.3c1.8,0,3,0,2.9,1.7c-0.1,1.4-1.1,2.2-3.2,2.2l-1.7,0L71,5.5z M69.7,12.6H72 c2.2,0,3.2,0.6,3.1,2.1c-0.2,1.9-1.4,2.5-3.9,2.5h-2.4L69.7,12.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.8,23.8 84.8,23.8 78.1,36.7 78,36.7 76.2,23.8 71.2,23.8 74.3,42.6 79.5,42.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.9,42.6 121.4,42.6 125.2,23 120.7,23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.8,41.6c1.3,0.6,3.3,1.5,6,1.2c4.7-0.5,7-1.9,7.4-5.4c0.5-4.6-6.7-3-6.8-5.1c0-1,1.5-1.4,2.6-1.4 c1.6,0,3.2,0.9,4.6,1.7l0.7-3.7c-1.7-0.6-4.2-0.9-5.4-0.9c-3.4,0-7.2,2-7.2,5.3c0,4.8,6.8,3.2,6.8,5.2c0,1.2-1.7,1.4-2.4,1.4 c-1.3,0-3.5-0.5-5.3-2.1L146.8,41.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "111.5,23.8 106.6,23.8 99.9,36.7 99.8,36.7 98,23.8 93,23.8 96.1,42.6 101.3,42.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.5,42.6 129,42.6 132.8,23 128.2,23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.1,42.6h4.7c0.5-4.2,1.5-7.6,1.7-9.8c0.3-3.1-1.6-4.8-6-4.8c-2.2,0-3.9,0.3-5.8,0.6l-0.5,3.5 c1.6-0.8,3.5-1.1,5.2-1.1c1.6,0,2.5,0.7,2.5,1.7c0,0.2,0,0.4-0.1,0.6c-0.7-0.1-1.5,0.1-2.5,0.1c-4.2,0.2-7.4,2-7.7,5.4 c-0.2,2.8,1.1,4,4.1,4c1.8,0,3-0.7,4.5-1.8l0,0.3L140.1,42.6z M136.3,38.8c-0.2-1.6,1.1-2.7,3.6-2.8c0.3,0,0.8-0.1,1.5-0.1 c-0.2,1.6-0.5,3-0.5,3c-0.7,0.6-1.6,0.9-2.5,1C137.3,40,136.4,39.7,136.3,38.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.6,42.6h4.8l2-4h6.2l0.4,4H71l-3-18.8h-5.2L52.6,42.6z M65.2,35.3h-4.1l3.2-6.3L65.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,42.6h4.5l2.7-14.2H112L109.3,42.6z M112.3,26.4h4.8l0.7-3.4H113L112.3,26.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvVillas);
export default __webpack_public_path__ + "static/media/logo-av-villas.ce3bb311a9aed4b37b64adf1e4bcd5af.svg";
export { ForwardRef as ReactComponent };